enum TagType {
  USER_DEFINED = 'USER_DEFINED',
  IMPRV_DEFINED = 'IMPRV_DEFINED'
}

interface TagModel {
  entityId?: string;
  type?: TagType;
  text: string;
}

export { TagType };

export type { TagModel };
